import React from 'react';


export default ({ enabled }) => <span style={{ color: enabled ? '#00e304' : '#e62222' }} className="fa fa-circle" />;
